<template>
  <div
    class="block-wrap block-specification"
    style="padding:10px">
    <div
      v-for="(s, sindex) in specifications"
      :key="sindex">
      <div class="title-bg">
        规格名：
        <template>
          <el-input :disabled="disabledSpName || isPureType" style="width:140px" v-model="s.name" @keyup.enter.native="(e) => nameEnter(sindex)" @change="e => nameChange(s)" :maxlength="20"></el-input>
          <UsualSpecification :disabled="isPureType" @usual="(usualSp) => usualSpClick(usualSp, sindex)" :spName="s.name" v-if="!isPlatform" />
        </template>
        <el-button v-if="remarkKey" style="float: right; margin-right: 8px" type="link" @click="openBatchRemarkDialog(s.name)">批量设置规格备注</el-button>
        <el-button style="float: right" v-show="showDelSpNameBtn" type="link" :disabled="isPureType" @click="removeSpName(sindex)">删除</el-button>
      </div>
      <div v-if="isPlatform && showAddSkuTips && sindex === 0 && !isGroupPuhuo" class="add-sku-tips">
        <div>
          如需添加新的规格值,请至<el-link @click="changeToBase">【基础资料】</el-link>进行添加
        </div>
        <span @click="handleNoTips" class="tips-btn">不再提示</span>
      </div>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left:10px;">规格值：</div>
        <vue-draggable class="specification-value-flex" v-model="specifications[sindex].values" filter=".drag-ignore_item" handle=".drag-icon-wrap" :group="{ name: s.name, pull: 'clone', put: false }" :animation="500">
          <div
            v-for="(v, vi) in specifications[sindex].values"
            :key="v.valueKey+vi"
            class="specification-value-flex_item" style="margin-bottom:16px">
            <div class="del-input-wrap">
              <el-input
                :ref="`${sindex}-${vi}`"
                :disabled="disabledSpValue || isPureType"
                placeholder="请输入"
                :maxLength="platform === 'wxsph' ? 40 : undefined"
                @blur="(e) => blurHandle(sindex, vi, e, v)" class="specification-value-flex_input"
                @keyup.enter.native="(e) => valueEnter(sindex, vi)"
                @input="(e) => handleInput(e, v)"
                v-model="v.value"></el-input>
              <div v-if="!isPlatform" @click="removeSpValue(sindex, vi, v)" class="del-btn"><i class="el-icon-close" /></div>
              <el-checkbox
                v-else
                style="margin-left: 8px"
                v-model="v.checked"
                @change="e => onChangeCheckbox(v)"
                :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1 || isPureType"></el-checkbox>
              <drag-item-content></drag-item-content>
            </div>
            <div v-if="remarkKey" class="remarkWrap">
              <el-input
                class="input-remark"
                :ref="`${sindex}-${vi}-remark`"
                placeholder="属性备注"
                :disabled="isPureType"
                @input="e => remarkInput(v)"
                v-model="v[remarkKey]"></el-input>
            </div>
            <div v-if="sindex === 0 && !noSpPic" class="specification-value-flex_img">
              <ImgUpload
                :ref="`${sindex}-${vi}-img`"
                :class="{'is-error': imgErrMsgs[`${sindex}-${vi}-img`]}"
                :outerId="outerId"
                :width="80"
                :height="80"
                :size="150"
                :file="v.imageUrl==='/resources/css/build/images/no_pic.png' ? '' : v.imageUrl"
                @upload-success="(url) => imageUploadSuccess(url, v, sindex, vi)"
                @del="() => imageUploadDel(v, sindex, vi)"
                v-bind="imgLimits"
                :isSingle="true"
                :isPureType="isPureType"
                :show-audit-result="showAuditResult"
                :auditFileList="auditFileList"
                :autoCropImageParams="autoCropImageParams"
              />
              <div v-if="imgErrMsgs[`${sindex}-${vi}-img`]" class="el-form-item__error">
                {{ imgErrMsgs[`${sindex}-${vi}-img`] }}
              </div>
            </div>
          </div>
          <div v-if="!isPlatform" class="specification-value-flex_item drag-ignore_item">
            <el-button @click="addSpValue(sindex)" :disabled="isPureType" type="link">添加规格值</el-button>
          </div>
        </vue-draggable>
        <div class="tips ft-12 ml-70" v-if="sindex === 0 && !noSpPic" style="color:#ccc;">
          <span>{{ tipText }}</span>
        </div>
      </div>
    </div>
    <div v-show="showAddSpNameBtn" class="title-bg">
      <el-button @click="addSpName" :disabled="isPureType">添加商品规格</el-button>
    </div>
    <BatchSetSpecRemarksDialog ref="batchSetSpecRemarksDialogRef"/>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload'
import UsualSpecification from '../UsualSpecification/index.vue'
import BatchSetSpecRemarksDialog from '@/components/prod/center/components/BaseInfoForm/components/BatchSetSpecRemarksDialog.vue';
import { dragItemMixin } from '../../utils/mixins'

export default {
  inject: {
    isGroupPuhuo: {
      default: false
    },
    disabledSpName: {
      default: false
    },
    disabledSpValue: {
      default: false
    },
    noSpPic: {
      default: false
    },
  },
  components: {
    ImgUpload,
    UsualSpecification,
    BatchSetSpecRemarksDialog
  },
  mixins: [dragItemMixin],
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      type: Array,
      default() {
        return []
      }
    },
    isPlatform: {
      type: Boolean,
      default: false
    },
    changeToBase: { // 打开基础资料编辑
      type: Function,
      default: () => {}
    },
    imgLimitSuffix: { // 图片类型限制
      type: String,
      default: '.jpg,.jpeg,.png,.gif'
    },
    remarkKey: {
      type: String,
      default: ''
    },
    pureType: {
      type: Number,
      default: 0
    },
    showAuditResult: {
      type: Boolean,
      default: false
    },
    auditFileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    imgLimits: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tipText: {
      type: String,
      default: '默认取商品第一张主图，买家选择不同规格会看到对应规格图片，建议尺寸：800 x 800像素，建议格式：png，jpg，jpeg格式'
    },
    outerId:{
      type: String,
      default: ''
    },
    platform:{
      type: String,
      default: ''
    },
    autoCropImageParams:{
      type: Object,
      default: () => {
        return {targetWidth:800,targetHeight:800}
      }
    },
  },
  data() {
    return {
      specifications: [],
      showAddSkuTips: true,
      specOptions: [], // 规格名下拉框列表项
      selectLoading: false, // 规格名下拉框loading
      isPureType: false,
      imgErrMsgs: {},
    }
  },
  computed: {
    showDelSpNameBtn() {
      return !this.isPlatform && this.specifications.length > 1
    },
    showAddSpNameBtn() {
      return !this.isPlatform && this.specifications.length <= 5
    },
  },
  watch: {
    values:{
      handler(v) {
        this.specifications = v
        this.$nextTick(() => {
          this.checkAllErrors()
        })
      },
      immediate: true,
    },
    pureType: {
      handler(val){
        this.isPureType = val === 0 ? false : true;
      },
      immediate: true
    },
  },
  mounted() {
      const noTips = localStorage.getItem('noSecTips');
      if (noTips === '1') {
        this.showAddSkuTips = false;
      }
  },
  methods: {
    openBatchRemarkDialog(name) {
      this.$refs.batchSetSpecRemarksDialogRef.method_open({
        name,
        remarkKey: this.remarkKey || 'note',
        specifications: this.specifications,
        sureFn: (specs) => {
          this.$emit('change', JSON.parse(JSON.stringify(specs)));
        },
      });
    },
    checkAllErrors() {
      if(!this.specifications?.length) return
      this.imgErrMsgs = {}
      this.specifications.forEach((item, sindex) =>{
        item.values.forEach((v, vi) => {
          if(Object.keys(this.imgLimits).length) {
            this.checkOneImgError(sindex, v, vi)
          }
          this.checkOneValueError(v, item)
        })
      })
    },
    async checkOneImgError(sindex, v, vi) {
      if(v.imageUrl) {
        const refImg = this.$refs[`${sindex}-${vi}-img`];
        if(refImg && refImg[0]) {
          let errMsg = await refImg[0].method_validImage()
          this.$set(this.imgErrMsgs, `${sindex}-${vi}-img`, errMsg)
        }
      } else {
        this.$set(this.imgErrMsgs, `${sindex}-${vi}-img`, '')
      }
    },
    checkOneValueError(v, item) {
      if(this.platform == 'tb') {
        if(item.formType == "taoSirProperty") return
        v.valueErrorMsg = ''
        if(item.options?.length && v.value && !item.valueAttributeRuleList?.includes('inputValue') && item.checked) {
          const isFind = item.options.find(op => op.displayName == v.value)
          if(!isFind) {
            v.valueErrorMsg = '规格值匹配失败，请重新选择'
          }
        }
      }
    },
    // 属性备注输入事件
    remarkInput(v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationRemark_changed = true  // 用于skuList生成时的图片取值规则
    },
    nameChange(s) {
      this.$set(s, 'isEdited', true)
    },
    // 规格名回车事件
    nameEnter(sindex) {
      let firstInputVm = this.$refs[`${sindex}-0`] // 当前规格下的第一个规格值输入框
      firstInputVm = firstInputVm ? firstInputVm[0] : firstInputVm
      if (!firstInputVm) {
        if (this.isPlatform) return ; // 平台资料不允许新增规格值
        // 为空需要创建一个
        this.addSpValue(sindex)
        this.$nextTick(() => {
          this.$refs[`${sindex}-0`][0].focus()
        })
      } else {
        // 聚焦到第一个
        firstInputVm.focus()
      }
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`]
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm
      if (!nextInputVm) {
        if (this.isPlatform) return ; // 平台资料不允许新增规格值
        this.addSpValue(sindex)
        this.$nextTick(() => {
          this.$refs[`${sindex}-${vindex + 1}`][0].focus()
        })
      } else {
        // 聚焦到下一个
        nextInputVm.focus()
      }
    },
    // 规格值输入事件
    blurHandle(sindex, vi, e, v) {
      const _value = e.target.value
      if (!_value) return this.$message.error('请填写规格值')
      if(this.platform == 'wxsph' && _value.length>40) return this.$message.error('规格值超过40字符，请重新输入')
      const values = this.specifications[sindex].values
      let isSame = false
      values.forEach((item, i) => {
        if (vi !== i && item.value === e.target.value) {
          isSame = true
        }
      })
      if (isSame) { 
        this.$message.error('请勿输入相同规格值')
      }
    },
    // 添加规格名
    addSpName() {
      // 由于erp必须要有颜色与尺码的nameKey
      // 所以先判断当前是否有颜色与尺码，没有的话，优先加入颜色、再是尺码的nameKey、最后是自己的生成的key
      let nameKey = ''
      const nowNameKeys = this.specifications.map(item => item.nameKey)
      const hasColor = nowNameKeys.includes('颜色')
      const hasSize = nowNameKeys.includes('尺码')
      if (hasColor && hasSize) {
        nameKey = this.$utils.genkey.get('n')
      } else if (hasColor) {
        nameKey = '尺码'
      } else {
        nameKey = '颜色'
      }

      this.specifications.push({
        name: '',
        nameKey,
        values: []
      })
    },
    // 移除规格名
    removeSpName(index) {
      this.specifications.splice(index, 1)
      this.specifications?.length && this.$set(this.specifications[0], 'isEdited', true)
      this.$emit('fieldChanged');
    },
    // 移除规格值
    removeSpValue(sindex, index, v) {
      if(this.isPureType) return;
      this.$set(this.specifications[sindex], 'isEdited', true)
      const _copy = [].concat(this.specifications[sindex].values)
      _copy.splice(index,1)
      this.$set(this.imgErrMsgs, `${sindex}-${index}-img`, '')
      this.specifications[sindex].values = _copy
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
      this.$emit('fieldChanged');
    },
    valueInput(v) {
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
      this.$emit('fieldChanged');
    },
    handleInput(e, v) {
      // 原有的valueInput逻辑
      this.valueInput(v);
      this.$set(v, 'isEdited', true)
      // 微信视频号平台特殊处理
      if (this.platform === 'wxsph' && e.length > 40) {
        this.$message.error('规格值不能超过40个字符');
      }

    },
    onChangeCheckbox(v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationCheckbox_changed = true;
      this.$emit('fieldChanged');
    },
    onChangeSpCheckbox(s) {
      this.$set(s, 'isEdited', true)
      window.__spcificationSpCheckbox_changed = true;
      this.$emit('fieldChanged');
    },
    
    // 添加规格值
    addSpValue(index) {
      let voidValue = {
        value: '',
        checked: true,
        valueKey: this.$utils.genkey.get('v'),
        note: ''
      }
      if (index === 0) voidValue.imageUrl = '';
      this.specifications[index].values.push(voidValue)
      this.$set(this.specifications[index], 'isEdited', true)
      window.__spcificationImg_changed = voidValue.valueKey // 用于skuList生成时的图片取值规则
    },
    // 填充常用规格值
    usualSpClick(usualSp, index) {
      if (!usualSp.length) {
        this.$message.error('请先设置常用规格')
        return;
      }

      let usual_values = usualSp.map(usp => {
        let voidValue = {
          value: usp,
          checked: true,
          valueKey: this.$utils.genkey.get('v_'+usp)
        }
        if (index === 0) voidValue.imageUrl = '';
        return voidValue
      })
      this.specifications[index].isEdited = true
      this.specifications[index].values = usual_values
    },

    imageUploadSuccess(url, v, sindex, vi) {
      this.$set(v, 'isEdited', true)
      this.checkImgError && this.checkImgError(); // 淘宝用的
      this.checkOneImgError(sindex, v, vi)
      v.imageUrl = url;
      this.$emit("change", JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('file-upload', url)
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v, sindex, vi) {
      this.$set(v, 'isEdited', true)
      v.imageUrl = '';
      this.checkImgError && this.checkImgError(); // 淘宝用的
      this.checkOneImgError(sindex, v, vi)
      this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    handleNoTips() {
      this.showAddSkuTips = false;
      localStorage.setItem('noSecTips', 1);
    },
  }
}
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #DCDFE6;
  

  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
}

.specification-value {
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    &_item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    &_img {
      width: 82px;
      height: 82px;
      margin-top: 10px;
      position: relative;
    }
    .el-input {
      width: 160px;
    }
    .specification-value-flex_item {
      .el-form-item__error {
        margin-left: 0 !important;
      }
    }
  
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0,0,0,.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
.my-dynamic-class{
  display: block;
}
.specification-value-flex_img {
  width: 100%;
}
.is-error  {
  ::v-deep .el-input__inner,.file-img {
    border-color: #F56C6C;
  }
}
</style>